export default "/images/onboardingbg.png?7790923423cf43b308d1995dc2de84a4";